var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"cube-rate-item",class:{
  'cube-rate-item_active': _vm.index <= _vm.$parent.tempValue,
  'cube-rate-item_half_active': _vm.index === _vm.$parent.tempValue + 0.5
}},[_vm._t("default",function(){return [_c('div',{staticClass:"cube-rate-item-def"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }